/* Studio SEN — theme interactivity.
   Cart is the REAL Shopify cart (AJAX API), not localStorage. */
(function(){

  /* ---- cart count from Shopify ---- */
  function paintCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = String(n||0);
    });
  }
  function refreshCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(c){paintCount(c.item_count);}).catch(function(){});
  }

  /* ---- add-to-cart toast ---- */
  var toast;
  function flash(msg){
    if(!toast){
      toast = document.createElement('div');
      toast.className = 'sen-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(function(){
      toast.style.opacity='1'; toast.style.transform='translateX(-50%) translateY(0)';
    });
    clearTimeout(flash._t);
    flash._t = setTimeout(function(){
      toast.style.opacity='0'; toast.style.transform='translateX(-50%) translateY(20px)';
    }, 1800);
  }

  /* ---- ajax add-to-cart on any .js-cart-form ---- */
  function initForms(){
    document.querySelectorAll('form.js-cart-form').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var label = form.dataset.name || 'Artwork';
        if(btn) btn.disabled = true;
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: 1 })
        })
        .then(function(r){return r.ok?r.json():r.json().then(function(x){return Promise.reject(x);});})
        .then(function(){ flash('Added to cart · '+label); refreshCount(); })
        .catch(function(){ flash('Unavailable · '+label); })
        .finally(function(){ if(btn) btn.disabled = false; });
      });
    });
  }

  /* ---- variant selector (PDP + cards) ---- */
  window.selSize = function(btn){
    var row = btn.closest('.size-row');
    row.querySelectorAll('button').forEach(function(b){b.classList.remove('sel');});
    btn.classList.add('sel');
    var form = btn.closest('form');
    if(form && btn.dataset.variant){
      var idField = form.querySelector('[name=id]');
      if(idField) idField.value = btn.dataset.variant;
    }
    if(btn.dataset.image){
      var im = document.getElementById('pdpImg');
      if(im){ im.src = btn.dataset.image; im.srcset = ''; }
    }
    if(btn.dataset.price){
      var pr = document.getElementById('pdpPrice');
      if(pr) pr.textContent = btn.dataset.price;
    }
  };

  /* ---- product thumbnail gallery ---- */
  window.selImg = function(btn){
    var im = document.getElementById('pdpImg');
    if(im && btn.dataset.image){ im.src = btn.dataset.image; im.srcset = ''; }
    var row = btn.closest('.pdp-thumbs');
    if(row){
      row.querySelectorAll('.pdp-thumb').forEach(function(b){ b.classList.remove('on'); });
      btn.classList.add('on');
    }
    /* keep the lightbox opening on whichever photo is showing */
    var main = document.querySelector('.pdp-zoom');
    if(main && btn.dataset.idx) main.setAttribute('data-idx', btn.dataset.idx);
  };

  /* ---- lightbox (MD-Regulation-1 ch.9) ---- */
  function initLightbox(){
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.js-zoom'));
    if(!triggers.length) return;
    var canHover = window.matchMedia('(hover: hover)').matches;
    var lb, img, cap, fig, idx = 0, tapZoomed = false;

    function build(){
      lb = document.createElement('div');
      lb.className = 'sen-lb';
      lb.innerHTML =
        '<button type="button" class="sen-lb-close" aria-label="Close">✕</button>' +
        '<button type="button" class="sen-lb-nav sen-lb-prev" aria-label="Previous image">‹</button>' +
        '<button type="button" class="sen-lb-nav sen-lb-next" aria-label="Next image">›</button>' +
        '<div class="sen-lb-fig"><img alt=""></div>' +
        '<div class="sen-lb-cap"></div>' +
        '<div class="sen-lb-hint">' +
          (canHover ? 'Hover to zoom · Arrow keys to browse · Esc to close'
                    : 'Tap to zoom · Swipe to browse · Tap outside to close') +
        '</div>';
      document.body.appendChild(lb);
      lb.style.display = 'none';
      img = lb.querySelector('img');
      cap = lb.querySelector('.sen-lb-cap');
      fig = lb.querySelector('.sen-lb-fig');

      lb.querySelector('.sen-lb-close').addEventListener('click', close);
      lb.querySelector('.sen-lb-prev').addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
      lb.querySelector('.sen-lb-next').addEventListener('click', function(e){ e.stopPropagation(); step(1); });
      /* only the backdrop closes — the figure itself is the zoom target on touch */
      lb.addEventListener('click', function(e){
        if(e.target === lb) close();
      });

      /* cursor-tracked zoom, desktop only (9-2b, 9-4a) */
      if(canHover){
        fig.addEventListener('mouseenter', function(){ img.style.transform = 'scale(2.55)'; });
        fig.addEventListener('mousemove', function(e){
          var r = fig.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        });
        fig.addEventListener('mouseleave', function(){
          img.style.transform = 'scale(1)';
          img.style.transformOrigin = 'center center';
        });
      } else {
        /* touch: swipe to browse, tap to zoom at the touched point (9-2b, 9-4a) */
        var sx = 0, sy = 0, moved = false;
        fig.addEventListener('touchstart', function(e){
          if(e.touches.length !== 1) return;
          sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
        }, {passive:true});
        fig.addEventListener('touchmove', function(e){
          if(e.touches.length !== 1) return;
          if(Math.abs(e.touches[0].clientX - sx) > 12 || Math.abs(e.touches[0].clientY - sy) > 12) moved = true;
        }, {passive:true});
        fig.addEventListener('touchend', function(e){
          if(e.changedTouches.length !== 1) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if(moved){
            if(triggers.length > 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
            return;
          }
          var r = fig.getBoundingClientRect();
          tapZoomed = !tapZoomed;
          if(tapZoomed){
            img.style.transformOrigin =
              ((t.clientX - r.left) / r.width * 100) + '% ' + ((t.clientY - r.top) / r.height * 100) + '%';
            img.style.transform = 'scale(2.4)';
          } else {
            img.style.transform = 'scale(1)';
            img.style.transformOrigin = 'center center';
          }
        });
      }
    }

    function show(i){
      idx = (i + triggers.length) % triggers.length;
      var t = triggers[idx];
      img.src = t.getAttribute('data-full');
      cap.textContent = t.getAttribute('data-caption') || '';
      tapZoomed = false;
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    }
    function step(d){ show(idx + d); }

    function open(i){
      if(!lb) build();
      show(i);
      document.body.style.overflow = 'hidden';
      lb.style.display = 'flex';
      requestAnimationFrame(function(){ lb.classList.add('on'); });
      document.addEventListener('keydown', onKey);
    }
    function close(){
      lb.classList.remove('on');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      setTimeout(function(){ if(lb) lb.style.display = 'none'; }, 300);
    }
    function onKey(e){
      if(e.key === 'Escape') close();
      else if(e.key === 'ArrowLeft') step(-1);
      else if(e.key === 'ArrowRight') step(1);
    }

    triggers.forEach(function(t, i){
      t.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        open(i);
      });
    });

    /* expose so the product page's main image can open a specific index */
    window.senLB = { open: open };
  }

  /* product page: open the lightbox at the currently displayed image */
  window.senOpenLB = function(btn){
    var i = parseInt(btn.getAttribute('data-idx') || '0', 10);
    if(window.senLB) window.senLB.open(i);
  };

  /* ---- mobile nav toggle ---- */
  function initNav(){
    var burger = document.getElementById('burger');
    var links = document.querySelector('.nav-links');
    if(!burger || !links) return;
    burger.addEventListener('click', function(){
      var open = links.dataset.open === '1';
      links.dataset.open = open ? '0' : '1';
      if(open){ links.style.display=''; return; }
      links.style.display='flex';
      links.style.position='absolute';
      links.style.top='78px'; links.style.left='0'; links.style.right='0';
      links.style.flexDirection='column'; links.style.gap='0';
      links.style.background='var(--bg)'; links.style.borderBottom='1px solid var(--line)';
      links.querySelectorAll('a').forEach(function(a){
        a.style.padding='16px 20px'; a.style.borderTop='1px solid var(--line)';
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    refreshCount(); initForms(); initNav(); initLightbox();
  });
})();
